'use client';

import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const EmptyShiftWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  gap: ${Spacers.LG}rem;
`;

export const RatingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${Spacers.XXL}rem;
`;
